
import { useEffect, useState } from 'react';

interface StatProps {
  value: string;
  description: string;
  delay: number;
}

const StatItem = ({ value, description, delay }: StatProps) => (
  <div 
    className="bg-white rounded-2xl shadow-soft p-8 flex flex-col transition-all duration-500 hover:shadow-elevated hover:transform hover:-translate-y-1"
    style={{ transitionDelay: `${delay}ms` }}
  >
    <span className="text-4xl md:text-5xl font-bold text-brand-lightBlue mb-4">
      {value}
    </span>
    <p className="text-gray-700 text-lg">{description}</p>
  </div>
);

interface StatsSectionProps {
  visible: boolean;
}

const StatsSection = ({ visible }: StatsSectionProps) => {
  const stats = [
    {
      value: "85%",
      description: "of students regret their career choices due to lack of guidance."
    },
    {
      value: "70%",
      description: "of students in Kerala aspire to study abroad but don't know the best path."
    },
    {
      value: "60%",
      description: "of students choose careers due to peer pressure, not personal strengths."
    }
  ];

  return (
    <section className={`py-20 px-4 sm:px-6 md:px-8 transition-all duration-700 ease-in-out delay-200 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-brand-blue mb-12">
          Why Choosing the Right Career Matters?
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {stats.map((stat, index) => (
            <StatItem 
              key={index}
              value={stat.value}
              description={stat.description}
              delay={index * 100 + 200}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
